import React from "react";
import { FaLinkedin, FaTwitter, FaGithub } from "react-icons/fa";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Banner from "../components/Banner";

import Founder from "../assets/Founder.jpg";
import malePhoto from "../assets/avater-man.avif";
// import femalePhoto from "../assets/avater-women.avif";
import LazyImage from "../components/courseDetails/LazyImageLoader";

function TeamCard({ member, delay, large }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <motion.div
      ref={ref}
      className="bg-gradient-to-b from-white to-gray-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition duration-300 text-center border border-gray-100"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={inView ? { opacity: 1, scale: 1 } : {}}
      transition={{ duration: 0.5, delay }}
    >
      <div>
        <div className="bg-purple-900 p-6 h-28 w-full"></div>

        <div className="-mt-14">
          {inView ? (
            <LazyImage
              srcWebp={member.image}
              srcFallback={malePhoto}
              alt={member.name}
              imageClasses={`rounded-full mx-auto mb-4 object-cover ring-4 ring-gray-100 shadow-md w-24 h-24`}
            />
          ) : (
            <div
              className={`${
                large ? "w-32 h-32" : "w-24 h-24"
              } rounded-full mx-auto mb-4 bg-gray-400 animate-pulse`}
            />
          )}
        </div>

        <div className="px-6 mb-10">
          <h2
            className={`text-2xl md:text-3xl font-bold text-gray-800`}
          >
            {member.name}
          </h2>
          <p className="text-gray-500 text-sm">{member.position}</p>

          <div className="flex justify-center gap-3 mt-4">
            {member.linkedin && (
              <a
                href={member.linkedin}
                className="p-2 bg-blue-50 rounded-full text-blue-600 hover:bg-blue-100 transition"
              >
                <FaLinkedin size={large ? 20 : 18} />
              </a>
            )}
            {member.twitter && (
              <a
                href={member.twitter}
                className="p-2 bg-blue-50 rounded-full text-sky-500 hover:bg-sky-100 transition"
              >
                <FaTwitter size={large ? 20 : 18} />
              </a>
            )}
            {member.github && (
              <a
                href={member.github}
                className="p-2 bg-gray-100 rounded-full text-gray-800 hover:bg-gray-200 transition"
              >
                <FaGithub size={large ? 20 : 18} />
              </a>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default function Team() {
  return (
    <>
      <Banner />

      <div className="bg-gray-50 min-h-screen py-12">
        <div className="max-w-7xl mx-auto px-4">
          <motion.h1
            className="text-4xl font-bold text-center mb-12"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Our Team
          </motion.h1>

          {/* Top Leaders */}
          <div className="flex flex-wrap justify-center gap-8 mb-16">
            {teamMembers.slice(0, 2).map(
              (member, index) =>
                member.isActive && (
                  <div className="w-full sm:w-80 md:w-96">
                    <TeamCard key={index} member={member} delay={index * 0.2} />
                  </div>
                )
            )}
          </div>

          {/* Rest of the Team */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8">
            {teamMembers
              .slice(2)
              .map(
                (member, index) =>
                  member.isActive && (
                    <TeamCard
                      key={index}
                      member={member}
                      delay={index * 0.15}
                    />
                  )
              )}
          </div>
        </div>
      </div>
    </>
  );
}

const teamMembers = [
  {
    name: "Mohammad Eyasin",
    position: "Founder & CTO",
    image: Founder,
    linkedin: "https://www.linkedin.com/in/yeasin-eng/",
    // twitter: "#",
    github: "https://github.com/YeasinSE",
    isActive: true,
  },
  {
    name: "May You",
    position: "Co-Founder & CEO",
    image: "https://via.placeholder.com/300",
    linkedin: "#",
    twitter: "#",
    github: "#",
    isActive: false,
  },
  {
    name: "Alex Brown",
    position: "Lead Developer",
    image: "https://via.placeholder.com/300",
    linkedin: "#",
    twitter: "#",
    github: "#",
    isActive: true,
  },
  {
    name: "Maria Johnson",
    position: "UI/UX Designer",
    image: "https://via.placeholder.com/300",
    linkedin: "#",
    twitter: "#",
    github: "#",
    isActive: true,
  },
  {
    name: "Maria Johnson",
    position: "UI/UX Designer",
    image: "https://via.placeholder.com/300",
    linkedin: "#",
    twitter: "#",
    github: "#",
    isActive: true,
  },
];
